import { isObject } from "lodash-es";
import { defineComponent, createElementBlock, openBlock, createElementVNode, renderSlot, withDirectives, Fragment, renderList, toDisplayString, vShow } from "vue";
import { _ as _export_sfc } from "./chunks/_plugin-vue_export-helper.js";
const _sfc_main = defineComponent({
  name: "PChips",
  props: {
    items: {
      type: Array,
      default: () => []
    },
    itemText: {
      type: String,
      default: "text"
    }
  },
  emits: ["click:chip", "click:overflow"],
  data() {
    return {
      maxChipsDisplayed: 1
    };
  },
  watch: {
    items() {
      this.resizeFilterChips();
    }
  },
  mounted() {
    this.resizeFilterChips();
    this.$nextTick(() => {
      window.addEventListener("resize", this.resizeFilterChips);
    });
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.resizeFilterChips);
  },
  methods: {
    resizeFilterChips() {
      this.maxChipsDisplayed = this.items.length;
      this.$nextTick(() => {
        if (!this.$refs.filterChipsRowInner) {
          return;
        }
        const filterChipsRowElement = this.$refs.filterChipsRow;
        const filterChipsRowInnerElement = this.$refs.filterChipsRowInner;
        const afterSlotContainerElement = this.$refs.afterSlotContainer;
        const beforeSlotContainerElement = this.$refs.beforeSlotContainer;
        const chips = filterChipsRowInnerElement.children;
        let totalInnerWidth = 0;
        const overflowChipWidth = 42;
        const totalExtraWidth = beforeSlotContainerElement.offsetWidth + afterSlotContainerElement.offsetWidth + overflowChipWidth;
        for (let i = 0; i < chips.length; i++) {
          totalInnerWidth += chips[i].offsetWidth;
          if (totalInnerWidth + totalExtraWidth >= filterChipsRowElement.offsetWidth) {
            this.maxChipsDisplayed = i;
            break;
          }
        }
      });
    },
    getItemText(item) {
      return typeof item === "string" ? item : isObject(item) ? item[this.itemText] : "";
    }
  }
});
const _hoisted_1 = {
  ref: "filterChipsRow",
  class: "flex w-full items-center"
};
const _hoisted_2 = { ref: "beforeSlotContainer" };
const _hoisted_3 = {
  ref: "filterChipsRowInner",
  class: "flex divide-x divide-p-blue-30 overflow-hidden rounded-md border border-p-blue-30 bg-transparent text-xs font-medium leading-4 text-p-purple-60"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = { class: "inline-block truncate" };
const _hoisted_6 = { ref: "afterSlotContainer" };
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1, [
    createElementVNode("div", _hoisted_2, [
      renderSlot(_ctx.$slots, "before", {}, void 0, true)
    ], 512),
    createElementVNode("div", _hoisted_3, [
      (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.items.slice(0, _ctx.maxChipsDisplayed), (item, idx) => {
        return openBlock(), createElementBlock("div", {
          key: `${_ctx.getItemText(item)}_${idx}`,
          class: "flex cursor-pointer items-center px-3 py-1 hover:bg-p-blue-20",
          onClick: ($event) => _ctx.$emit("click:chip", item)
        }, [
          createElementVNode("div", _hoisted_5, toDisplayString(_ctx.getItemText(item)), 1),
          _cache[1] || (_cache[1] = createElementVNode("i", { class: "bg-cross ml-2 inline-block h-1.5 w-1.5" }, null, -1))
        ], 8, _hoisted_4);
      }), 128)),
      withDirectives(createElementVNode("div", {
        class: "cursor-pointer px-3 py-1 hover:bg-p-blue-20",
        onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("click:overflow"))
      }, " +" + toDisplayString(_ctx.items.length - _ctx.maxChipsDisplayed), 513), [
        [vShow, _ctx.items.length > _ctx.maxChipsDisplayed]
      ])
    ], 512),
    createElementVNode("div", _hoisted_6, [
      renderSlot(_ctx.$slots, "after", {}, void 0, true)
    ], 512)
  ], 512);
}
const pChips = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__scopeId", "data-v-57d9f151"]]);
export {
  pChips as default
};
